import { render } from "./insurance-plan.vue?vue&type=template&id=ee5684ee&scoped=true&ts=true"
import script from "./insurance-plan.vue?vue&type=script&lang=ts"
export * from "./insurance-plan.vue?vue&type=script&lang=ts"

import "./insurance-plan.vue?vue&type=style&index=0&id=ee5684ee&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee5684ee"]])

export default __exports__